import React from 'react';
import styled from 'styled-components';
import { BaseBox } from '@docon/docon-ui-library';
import { environment } from '../environments/environment';

interface IProps {
  [key: string]: any;
  src: string;
  size?: number;
  ignoreAssetsPath?: boolean;
  alt?: string;
}

const assetsPath = environment.PUBLIC_URL || '';
function Image({ src, size, ignoreAssetsPath, ...props }: IProps) {
  if (size) {
    props = Object.assign({ ...props }, { width: size, height: size });
  }

  return (
    <BaseBox
      as='img'
      loading='lazy'
      alt='alt'
      src={`${ignoreAssetsPath ? '' : assetsPath}${src}`}
      {...props}
    />
  );
}
export default styled(Image)``;